import React from 'react';

import { DRAWER_TABS_V3 } from '../drawer-tabs-v3';
import { useProductDetailsContext } from '../../use-product-details-context';
import { useIsUnitsOfMeasureAvailable } from '../../../../feature-gates/use-is-units-of-measure-available';

const DEFAULT_TAB = DRAWER_TABS_V3[0];
const UOM_TAB_ID = 'product-units-of-measure';

export const ProductDetailsDrawerContent = () => {
  const { selectedTab } = useProductDetailsContext();
  const { isLdEnabled } = useIsUnitsOfMeasureAvailable();

  const activeTab = DRAWER_TABS_V3.find((tab) => tab.id === selectedTab && (tab.id !== UOM_TAB_ID || isLdEnabled)) ?? DEFAULT_TAB;

  return <>{activeTab.render()}</>;
};
